export default "__VITE_ASSET__r8uad3GI__"